import { Navigate } from "react-router-dom";
import { useFinanceAccess } from "@/shared/hooks/useFinanceAccess";
import { Loader2, ShieldAlert } from "lucide-react";

const FinanceGuard = ({ children }: { children: React.ReactNode }) => {
  const { canAccessFullFinance, loading } = useFinanceAccess();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!canAccessFullFinance) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center space-y-4">
        <ShieldAlert className="h-12 w-12 text-muted-foreground" />
        <div>
          <h2 className="font-display text-lg font-semibold text-foreground">Acesso Restrito</h2>
          <p className="text-sm text-muted-foreground mt-1">
            Você não tem permissão para acessar o módulo financeiro.
          </p>
          <p className="text-xs text-muted-foreground mt-1">
            Fale com um administrador para solicitar acesso.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default FinanceGuard;
